export const durationDisplay = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const minutesLeft = minutes % 60;
  const hourStr = hours > 1 ? 'hours' : 'hour';
  const minuteStr = minutesLeft > 1 ? 'minutes' : 'minute';
  const hoursDisplay = hours > 0 ? `${hours} ${hourStr}` : '';
  const minutesDisplay = minutesLeft > 0 ? `${minutesLeft} ${minuteStr}` : '';
  return `${hoursDisplay} ${minutesDisplay}`.trim();
};
